export type UserLevel = 'FREE' | 'STANDARD' | 'PROFESSIONAL'

export interface LevelMeta {
  color: string
  bg: string
  border: string
  accentBg: string
}

export interface LevelQuota {
  monthlyFeeNum: number
  conversionGib: number
  storageGib: number
  streamingGib: number
  /** 다운로드 정책: 'none' 미제공, 'payg' 종량제 (표시 문구는 usePlanText 가 번역) */
  downloadKey: DownloadKey
}

export type DownloadKey = 'none' | 'payg'

/** 영어 화면에서 참고용으로 덧붙이는 USD 환산 환율(원/달러). 실제 청구는 항상 원화다. */
export const KRW_PER_USD = 1400

export const LEVEL_META: Record<UserLevel, LevelMeta> = {
  FREE:         { color: 'text-emerald-300', bg: 'bg-emerald-800', border: 'border-emerald-500', accentBg: 'bg-emerald-900/40' },
  STANDARD:     { color: 'text-blue-300',    bg: 'bg-blue-800',    border: 'border-blue-500',    accentBg: 'bg-blue-900/40' },
  PROFESSIONAL: { color: 'text-purple-300',  bg: 'bg-purple-800',  border: 'border-purple-500',  accentBg: 'bg-purple-900/40' },
}

export const LEVEL_QUOTA: Record<UserLevel, LevelQuota> = {
  FREE:         { monthlyFeeNum: 0,      conversionGib: 5,   storageGib: 5,   streamingGib: 15,   downloadKey: 'none' },
  STANDARD:     { monthlyFeeNum: 99000,  conversionGib: 50,  storageGib: 100, streamingGib: 200,  downloadKey: 'payg' },
  PROFESSIONAL: { monthlyFeeNum: 590000, conversionGib: 200, storageGib: 500, streamingGib: 1000, downloadKey: 'payg' },
}

export const LEVEL_ORDER: UserLevel[] = ['FREE', 'STANDARD', 'PROFESSIONAL']
